(function(){
  var debugPrefix = '[AdditionalStory Global]';
  function log(){}
  function warn(){}

  function initStory(container){
    var progressBar = container.querySelector('.additional-story__progress-bar');
    var sliderEl = container.querySelector('.swiper.story-slider');
    if (!progressBar || !sliderEl) { log(debugPrefix, 'skip container, missing elements', { hasProgressBar: !!progressBar, hasSliderEl: !!sliderEl }); return; }

    var playBtn = container.querySelector('[id^="story-btn-play--"]');
    var pauseBtn = container.querySelector('[id^="story-btn-pause--"]');
    var replayBtn = container.querySelector('[id^="story-btn-replay--"]');
    log(debugPrefix, 'init container', { id: container.id, hasPlayBtn: !!playBtn, hasPauseBtn: !!pauseBtn, hasReplayBtn: !!replayBtn });

    function getActiveVideo(){
      var active = sliderEl.querySelector('.swiper-slide.swiper-slide-active');
      var v = active ? active.querySelector('video') : null;
      log(debugPrefix, container.id, 'getActiveVideo', { hasActive: !!active, hasVideo: !!v });
      return v;
    }

    function setVisibility(el, visible){
      if (!el) return;
      el.classList.toggle('hide', !visible);
      el.setAttribute('aria-hidden', visible ? 'false' : 'true');
    }

    function updateButtonsFromVideo(video){
      var showPlay = false, showPause = false, showReplay = false;
      if (!video) {
        showPlay = true; // sans vidéo active, garder Play par défaut
      } else if (video.ended) {
        showReplay = true;
        showPlay = true; // garder Pause visible quand la vidéo est finie
      } else if (video.paused) {
        showPlay = true;
      } else {
        showPause = true;
      }
      setVisibility(playBtn, !!showPlay);
      setVisibility(pauseBtn, !!showPause);
      setVisibility(replayBtn, !!showReplay);
      log(debugPrefix, container.id, 'updateButtons', { showPlay, showPause, showReplay });
    }

    function updateFromVideo(video){
      var progress = container.querySelector('.additional-story__progress');
      if (!video) { progressBar.style.width = '0%'; progress && progress.setAttribute('aria-valuenow', 0); log(debugPrefix, container.id, 'no video to update'); return; }
      var duration = 0;
      // 1) durée native si dispo
      if (video.duration && isFinite(video.duration) && video.duration > 0) {
        duration = video.duration;
      }
      // 2) attribut sur la vidéo
      if (!duration) {
        var fromVideoAttr = parseFloat(video.getAttribute('data-video-duration'));
        if (isFinite(fromVideoAttr) && fromVideoAttr > 0) duration = fromVideoAttr;
      }
      // 3) attribut sur le slide parent
      if (!duration) {
        var slide = video.closest('.swiper-slide');
        if (slide) {
          var fromSlideAttr = parseFloat(slide.getAttribute('data-video-duration'));
          if (isFinite(fromSlideAttr) && fromSlideAttr > 0) duration = fromSlideAttr;
        }
      }
      if (!duration || !isFinite(duration)) { log(debugPrefix, container.id, 'invalid duration', { duration }); return; }
      var pct = (video.currentTime / duration) * 100;
      if (pct < 0) pct = 0; if (pct > 100) pct = 100;
      progressBar.style.width = pct + '%';
      progress && progress.setAttribute('aria-valuenow', Math.round(pct));
      if (Math.abs(pct - 100) < 0.5) { log(debugPrefix, container.id, 'progress 100%'); }
    }

    function showReplayUI(){
      log(debugPrefix, container.id, 'showReplayUI');
      setVisibility(replayBtn, true);
      setVisibility(playBtn, false);
      setVisibility(pauseBtn, true); // afficher Pause à la fin
      var progress = container.querySelector('.additional-story__progress');
      progressBar.style.width = '100%';
      progress && progress.setAttribute('aria-valuenow', 100);
    }

    function hideReplayUI(){
      log(debugPrefix, container.id, 'hideReplayUI');
      setVisibility(replayBtn, false);
    }

    function bindVideo(video){
      if (!video || video.__storyReplayBound) return;
      video.__storyReplayBound = true;
      ['timeupdate','seeked','loadedmetadata','play','pause'].forEach(function(evt){
        video.addEventListener(evt, function(){ log(debugPrefix, container.id, 'video evt', evt, { currentTime: video.currentTime, duration: video.duration }); updateFromVideo(video); updateButtonsFromVideo(video); });
      });
      video.addEventListener('ended', function(){ log(debugPrefix, container.id, 'video ended'); showReplayUI(); updateButtonsFromVideo(video); });
      video.addEventListener('play', function(){ log(debugPrefix, container.id, 'video play'); hideReplayUI(); updateButtonsFromVideo(video); });
    }

    // Init now
    progressBar.style.width = '0%';
    var v = getActiveVideo();
    if (v) bindVideo(v);
    updateFromVideo(v);
    updateButtonsFromVideo(v);

    // Observe active slide changes
    var lastActive = null;
    var mo = new MutationObserver(function(){
      var active = sliderEl.querySelector('.swiper-slide.swiper-slide-active');
      if (active !== lastActive) {
        log(debugPrefix, container.id, 'active slide changed');
        lastActive = active;
        var v = getActiveVideo();
        if (v) bindVideo(v);
        updateFromVideo(v);
        updateButtonsFromVideo(v);
      }
    });
    mo.observe(sliderEl, { attributes: true, subtree: true, attributeFilter: ['class'] });

    if (replayBtn) {
      replayBtn.addEventListener('click', function(){
        log(debugPrefix, container.id, 'replay clicked');
        var v = getActiveVideo();
        if (!v) { warn(debugPrefix, container.id, 'no active video on replay'); return; }
        try { v.currentTime = 0; } catch(e) { warn(debugPrefix, container.id, 'failed to reset currentTime', e); }
        var p = v.play && v.play();
        if (p && typeof p.catch === 'function') { p.catch(function(err){ warn(debugPrefix, container.id, 'play() rejected', err); }); }
        updateButtonsFromVideo(v);
      });
    } else {
      warn(debugPrefix, container.id, 'replay button not found');
    }

    if (playBtn) {
      playBtn.addEventListener('click', function(){
        var v = getActiveVideo();
        if (!v) return;
        var p = v.play && v.play();
        if (p && typeof p.catch === 'function') { p.catch(function(){}); }
        updateButtonsFromVideo(v);
      });
    }

    if (pauseBtn) {
      pauseBtn.addEventListener('click', function(){
        var v = getActiveVideo();
        if (!v) return;
        try { v.pause(); } catch(e) {}
        updateButtonsFromVideo(v);
      });
    }
  }

  function initAll(){
    var containers = document.querySelectorAll('.additional-story');
    if (!containers.length) { log(debugPrefix, 'no containers found'); return; }
    containers.forEach(initStory);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
